import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Text from 'components/shared/Typography/Text';
import { OVERRIDDEN_BY_COOKIE } from 'constants/cookies';
import { CANCEL_OVERRIDE_PATH, getPath, USERS_PATH } from 'constants/routes';
import { logoutAsThunk } from 'store/auth/thunks';
import { userNameSelector } from 'store/user/selectors';
import axiosApi from 'utils/axios';
import { getCookie } from 'utils/cookies';
import logger from 'utils/logger';

import BackLink from '../../Form/Header/shared/BackLink';
import styles from './index.module.css';

function LoginAsBar() {
  const dispatch = useDispatch();
  const userName = useSelector(userNameSelector);
  const handleLogoutAs = async () => {
    const accountId = getCookie(OVERRIDDEN_BY_COOKIE);

    try {
      const path = window.location.origin + getPath(CANCEL_OVERRIDE_PATH, { accountId });
      await axiosApi.delete(path);
    } catch (e) {
      logger.error(e);
    } finally {
      dispatch(logoutAsThunk());

      window.location = getPath(USERS_PATH, { accountId });
    }
  };

  return (
    <div className={styles.bar}>
      <BackLink className={styles.link} isButton onClick={handleLogoutAs}>
        Switch back to Admin
      </BackLink>
      <div className={styles.userName}>
        <Text accent className={styles.text}>
          CURRENTLY CONTROLLING {userName} ACCOUNT
        </Text>
      </div>
    </div>
  );
}

export default LoginAsBar;
